import ListingsRoutingResolver from './ListingRoutingResolver';

class AccountingMiscListingRoutingResolver extends ListingsRoutingResolver {

    constructor() {
        super()
        this.key = "accounting-misc"
    }
}

export default AccountingMiscListingRoutingResolver
